<template>
  <section class="app-solicitacao">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">Acompanhar Solicitação</v-card-title>
            <v-card-text class="app-card-content pb-0">
              <v-form
                ref="form"
                lazy-validation
                @submit.prevent="onSubmit()"
                aria-autocomplete="false"
              >
                <v-row>
                  <v-col :md="6" :sm="6" :xs="12" cols="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="form.numero"
                      label="Número *"
                      placeholder="Digite seu número da solicitação"
                      :rules="[rules.required]"
                      v-mask="'################'"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="6" :sm="6" :xs="12" cols="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="form.email"
                      label="Email *"
                      placeholder="Digite o email informado na solicitação"
                      :rules="[rules.required, rules.email]"
                      filled
                      rounded
                      dense
                      type="email"
                    ></v-text-field>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12" class="pb-5">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="form.recaptcha"
                      :rules="[rules.required]"
                      style="margin-top:-27px;"
                    ></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12" class="pb-5">
                    <v-btn depressed block large color="primary" type="submit">Pesquisar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
          <div id="solicitacaoResult">
            <Solicitacao :data="solicitacao" v-if="solicitacao" />
            <Acompanhamentos :data="solicitacao.contatos" v-if="solicitacao" />
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { mask } from "vue-the-mask";
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import Solicitacao from "./Solicitacao";
import Acompanhamentos from "./Acompanhamentos";

import SolicitacaoService from "@/services/solicitacao.service";

export default {
  components: {
    VueRecaptcha,
    Solicitacao,
    Acompanhamentos
  },
  directives: {
    mask
  },
  metaInfo: {
    title: "Acompanhar Solicitação - Central de Serviços"
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      form: {
        numero: null,
        email: null,
        recaptcha: null
      },
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mail inválido.";
        },
        required: value => !!value || "Esse campo deve ser preenchido"
      },
      solicitacao: null
    };
  },
  methods: {
    reset() {
      this.sended = false;
    },
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        this.isLoading = true;
        const { numero, email, recaptcha } = this.form;
        SolicitacaoService.solicitaFindByIdAndEmail(
          numero,
          email,
          recaptcha
        ).subscribe(
          res => {
            this.solicitacao = res;
            this.isLoading = false;
            this.expiredRecaptcha();
            this.$vuetify.goTo("#solicitacaoResult");
          },
          error => {
            this.isLoading = false;
            this.expiredRecaptcha();
            this.solicitacao = null;
          }
        );
      }
    }
  }
};
</script>
